import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {setCameFromPage, toggleConfirmPopup, toggleSelectionFeatureInfo} from "../../../actions/actionFunctions";
import WithSqftFooterCancel from "../hocs/withSqftFooterCancel";

const SqftFooterCancelButton = (props) => {

  return (
    <WithSqftFooterCancel props={props}>
      {(handleCloseSQFtCalc) => (
        <button data-id="exit-button"
                className="exit-button ui-button10 ui-button10--blue"
                onClick={() => handleCloseSQFtCalc()} >
          <FormattedMessage id={"sqft.footer.buttonCancel"}/>
        </button>
      )}
    </WithSqftFooterCancel>
  )
};

const mapStateToProps = (store) => ({
  cameFromPage: store.cartState.cameFromPage,
  showManualCalculation: store.sqftManualCalculationState.showManualCalculation,
});

const mapDispatchToProps = {
  toggleConfirmPopup,
  toggleSelectionFeatureInfo,
  setCameFromPage
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftFooterCancelButton);
